var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayslipsDeep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.879 1.879A3 3 0 016 1h7a1 1 0 01.707.293l7 7A1 1 0 0121 9v11a3 3 0 01-3 3H6a3 3 0 01-3-3V4a3 3 0 01.879-2.121zM6 3a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V9.414L12.586 3H6z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11c-.32 0-.6.255-.6.546v.218c-.8.181-1.4.836-1.4 1.6v.545c0 .91.8 1.636 1.8 1.636h.4c.36 0 .6.219.6.546v.545c0 .328-.24.546-.6.546h-.4c-.36 0-.6-.218-.6-.546 0-.29-.28-.545-.6-.545-.32 0-.6.255-.6.545 0 .764.6 1.419 1.4 1.6v.218c0 .291.28.546.6.546.32 0 .6-.255.6-.546v-.218c.8-.181 1.4-.836 1.4-1.6v-.545c0-.91-.8-1.637-1.8-1.637h-.4c-.36 0-.6-.218-.6-.545v-.545c0-.328.24-.546.6-.546h.4c.36 0 .6.218.6.546 0 .29.28.545.6.545.32 0 .6-.255.6-.545 0-.764-.6-1.419-1.4-1.6v-.218c0-.291-.24-.546-.6-.546z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zM13 13a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1a1 1 0 011 1v6h6a1 1 0 110 2h-7a1 1 0 01-1-1V2a1 1 0 011-1z",
    fill: "#000"
  })));
}
export default SvgPayslipsDeep;